// 侧边栏
// import { EnvironmentOutlined } from '@ant-design/icons';

const asideMenuConfig = [
  {
    name: '选址需求',
    path: '/',
    // icon: EnvironmentOutlined,
    icon: 'icon-xuanzhi',
  },
  // {
  //   name: '场地管理',
  //   path: '/lhb-micro-resource/placeMng',
  //   icon: 'icon-xuanzhi',
  // },
  // {
  //   name: '点位管理',
  //   path: '/lhb-micro-resource/pointMng',
  //   icon: 'icon-xuanzhi',
  // }
];

export { asideMenuConfig };
